import Catana from '../../images/sponsors/catana.png';
import GrupoPR from '../../images/sponsors/grupo-pr.png';
import Mystic from '../../images/sponsors/mystic.png';
import Palbit from '../../images/sponsors/palbit.svg';
import Quantal from '../../images/sponsors/quantal.png';
import Elio from '../../images/sponsors/elio.png';
import Coficab from '../../images/sponsors/coficab.png';
import Maximoferta from '../../images/sponsors/maximoferta.png';
import Movella from '../../images/sponsors/movella.png';
import SponsorCard from './SponsorCard';
import SimpleSponsorCard from './SimpleSponsorCard';
import { Link } from 'react-router-dom';

function Sponsors() {
    
    const platinum_sponsors = [
        {name: "Catana", link: 'https://www.catanagroup.com/en/', logo: Catana, description: "Catana Group Portugal, based in Vagos, is a company specializing in the leisure marine industry, specifically in the production of catamarans."},
        {name: "Grupo PR", link: 'https://www.prgrupo.com/pt/', logo: GrupoPR, description: "Grupo PR, based in Porto, specializes in industrial solutions for the automotive sector, including custom processes and precision components."},
        {name: "Mystic Invest", link: 'https://www.mysticinvest.com/', logo: Mystic, description: "Mystic Invest is a family-owned financial holding with multiple brands operating in the travel & tourism sector, in areas such as cruises, tours & attractions, hotels & resorts, space tourism, and real estate."},
        {name: "Palbit", link: 'https://www.palbit.pt/pt', logo: Palbit, description: "Palbit, based in Palhal, is a cutting tool manufacturer specializing in high-performance solutions for industries like aerospace and automotive."},
    ];

    const gold_sponsors = [
        {name: "Quantal", link: 'https://www.quantal.pt/', logo: Quantal},
        {name: "Coficab", link: 'https://www.coficab.com/', logo: Coficab},
        {name: "Elio Kayaks", link: 'http://www.eliokayaks.com/', logo: Elio},
        {name: "Maximoferta", link: 'https://www.maximoferta.com/pt/', logo: Maximoferta},
        {name: "Movella", link: 'https://www.movella.com/', logo: Movella}
    ];


    return (
        <div
            className="min-h-screen w-full flex flex-col justify-center items-center p-10"
            style={{
                background: "linear-gradient(to right, #7D8D99, #E4DACB)", 
            }}
        >
            <h1 className="md:text-8xl text-4xl text-white text-center font-bold z-10">Sponsors</h1>

            {/* Platinum Sponsors Section */}
            <h3 className="md:text-5xl text-2xl text-white text-center md:mt-40 mt-10 font-bold">Platinum</h3>
            <ul className="flex flex-wrap justify-center gap-x-48 gap-y-10 w-full">
                {platinum_sponsors.map((sponsor) => (
                    <SponsorCard key={sponsor.name} {...sponsor} />
                ))}
            </ul>

            {/* Gold Sponsors Section */}
            <h3 className="md:text-5xl text-2xl text-white text-center md:mt-40 mt-10 font-bold">Gold</h3>
            <ul className="flex flex-wrap justify-center gap-x-48 gap-y-10 w-full">
                {gold_sponsors.map((sponsor) => (
                    <SimpleSponsorCard key={sponsor.name} {...sponsor} />
                ))}
            </ul>

            <div className="flex justify-center mt-10">
                <Link to={"/sponsors"} 
                    
                    className="flex items-center justify-center w-12 h-12 bg-gray-200 text-gray-600 rounded-full hover:bg-opacity-90 transition-all duration-300 font-semibold text-2xl"
                >
                    +
                </Link>
            </div>
        </div>
    );
}

export default Sponsors;
